'use strict';

module.exports = 'Boolean Number String Date RegExp Function Array Error Set Map';


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/common/var/NATIVE_TYPES.js
// module id = 223
// module chunks = 0